import { SCREENS } from 'src/constants/screens';
import { ICustomTooltipProps, TOOLTIP_DURATION, TOOLTIP_POSITION } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import { TIntegrationsAvailability } from '~/types/integrations';

export enum Integrations {
  ADJUST = 'adjust',
  APPLE_PAY = 'apple-pay',
  CHECKOUT = 'checkout',
  CONNECT = 'connect',
  DOOK = 'dook',
  FOODICS = 'foodics',
  GOOGLE_MAPS = 'google-maps',
  GOOGLE_TAG_MANAGER = 'google-tag-manager',
  KUDU = 'kudu',
  MARN = 'marn',
  T360 = 'taker-360',
  TAKER_GO = 'taker-go',
  YALLOW = 'yallow',
}

export const defaultIntegrationsAvailability: TIntegrationsAvailability = {
  [Integrations.ADJUST]: false,
  [Integrations.APPLE_PAY]: false,
  [Integrations.CHECKOUT]: false,
  [Integrations.CONNECT]: false,
  [Integrations.DOOK]: false,
  [Integrations.FOODICS]: false,
  [Integrations.GOOGLE_MAPS]: false,
  [Integrations.GOOGLE_TAG_MANAGER]: false,
  [Integrations.KUDU]: false,
  [Integrations.MARN]: false,
  [Integrations.T360]: false,
  [Integrations.TAKER_GO]: false,
  [Integrations.YALLOW]: false,
};

export enum SyncStatus {
  FAILED = -1,
  PENDING = 0,
  PROCESSING = 1,
  COMPLETED = 2,
}

/**
 * Attention!!! Numbers in string format
 */
export enum POS_SYSTEM_ID {
  DISABLED = '0',
  FOODICS = '1',
  MARN = '2',
  KUDU = '3',
}

export enum RESTRICTION_ACCESS {
  ALLOWED = 1,
  DISABLED,
  HIDDEN,
}

export const screensWithPosNotifications: string[] = [
  SCREENS.MENU_GROUPS(),
  SCREENS.CATEGORIES(),
  SCREENS.ITEMS(),
  SCREENS.MODIFIERS(),
  SCREENS.EXCLUSIONS(),
  SCREENS.PRODUCTS(),
  SCREENS.MEALS(),
  SCREENS.MEAL_COMBOS(),
  SCREENS.BRANCHES(),
  SCREENS.SETTINGS(),
];

export const defaultIntegrationTooltipOptions: Partial<ICustomTooltipProps> = {
  duration: TOOLTIP_DURATION.EXTRA_LARGE,
  message: 'please_disable_posint',
  position: TOOLTIP_POSITION.FIXED,
  maxWidth: 355,
};
